const apiUrl = process.env.REACT_APP_API_URL;

const getLubricantBrandNames = (token, id, cb) => {
    fetch(`${apiUrl}/lubricantmanufacturers/${id}/lubricants`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getLubricantBrandNames;
